var map = {
	"./right_01.png": "1960",
	"./right_02.png": "0279",
	"./right_03.png": "040e",
	"./right_04.png": "b270",
	"./right_05.png": "58fb",
	"./right_06.png": "c948",
	"./right_07.png": "6a6d",
	"./right_08.png": "fca7",
	"./right_09.png": "ed46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9be";